<template>
  <section class="breadcrumbs">
      <ul class="breadcrumbs__list">
        <li class="breadcrumbs__list--item">
          <a href="/" class="breadcrumbs__list--link">Главная</a>
        </li>
        <li class="breadcrumbs__list--item">Контакты</li>
      </ul>
  </section>
</template>

<script>
export default {
  name: 'Breadcrumbs'
}
</script>

<style src="./component.scss" scoped lang="scss"/>
